import { render, staticRenderFns } from "./code.vue?vue&type=template&id=7881372e&scoped=true"
import script from "./code.vue?vue&type=script&lang=js"
export * from "./code.vue?vue&type=script&lang=js"
import style0 from "./code.vue?vue&type=style&index=0&id=7881372e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881372e",
  null
  
)

export default component.exports